import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import Numeral from 'numeral'
import * as R from 'ramda'

import Tooltip from 'rc-tooltip';
import TooltipContent from 'components/TooltipContent'
import 'rc-tooltip/assets/bootstrap.css';

import IconMenu from 'material-ui/IconMenu'
import MenuItem from 'material-ui/MenuItem'
import {Card, CardActions, CardHeader, CardText} from 'material-ui/Card'
import SelectField from 'material-ui/SelectField'
import Divider from 'material-ui/Divider'

import financeActions from 'actions/financeActions'
import tooltipsActions from 'actions/tooltipsActions'

import { incomeStatementByPropertyID, equityByPropertyID, principalPaidByPropertyID, taxDeferalByPropertyID, investmentByPropertyID, roiByPropertyID, roiWithGainByPropertyID, occupancyRateByPropertyID, daysForRentByPropertyID, perfomancePeriod, taxBracket } from 'selectors/perfomance'
import { currentUser } from 'selectors/common'
import { tooltipsData } from 'selectors/tooltip'

let select = (state, props) => ({
	incomeStatement: incomeStatementByPropertyID(state)
  , equity: equityByPropertyID(state)
  , principalPaid: principalPaidByPropertyID(state)
  , taxDeferal: taxDeferalByPropertyID(state)
  , investment: investmentByPropertyID(state)
  , roi: roiByPropertyID(state)
  , roiWithGain: roiWithGainByPropertyID(state)
  , occupancyRate: occupancyRateByPropertyID(state)
  , daysForRent: daysForRentByPropertyID(state)
  , currentUser: currentUser(state)
  , perfomancePeriod: perfomancePeriod(state)
  , tooltips: state.tooltips
  , tooltipsData: tooltipsData(state)
  , taxBracket: taxBracket(state)
})

export class PerfomanceSection extends Component {
	render() {
		let { props } = this
		let propertyID = props.selectedProperty || 'total'
		return (
			<Card
				key="FinanceCard"
				initiallyExpanded={true}
				style={{backgroundColor: "#FFF", border: "0px", boxShadow: "none", padding: "15px"}}
			>
				<CardHeader
					title={
						<div style={{display: 'flex'}}>
							<div
								style={{
									paddingLeft:"0px"
								  , whiteSpace: "nowrap"
								  , alignItems: "space-between"
								  , lineHeight: "35px"
								  , fontSize: "16px"
								  , fontWeight: "600"
								  , textTransform: "uppercase"
								}}
							>
								{props.selectedProperty ? "Property performance" : "Portfolio performance"}
							</div>
							<SelectField
								value={props.perfomancePeriod || 'YTM'}
								onChange={(evt, indx, value) => {
									props.SET_PERFOMANCE_PERIOD(value)
								}}
								labelStyle={{color: "#009687", fontSize: "16px", fontWeight: "bold", paddingRight: "0"}}
								style={{width: "180px", marginTop: "-7px", marginLeft: "15px", color: "#009687"}}
							>
								<MenuItem value={'YTM'} primaryText="2017 (YTM)" />
								<MenuItem value={'projected'} primaryText="2017 (Projected)" />
							</SelectField>
						</div>
					}
					textStyle={{width: "100%",paddingRight:"0px"}}
					style={{padding:"0px"}}
					showExpandableButton={false}
				/>
				<CardText expandable={true} style={{marginTop: "-20px", marginBottom: "-20px", padding: "16px 16px 16px 0"}}>
					<table
						style={{
							width: "100%"
						  , verticalAlign:"top"
						  , padding: "0 0px 15px 10px"
						  , fontSize: "16px", lineHeight: "2"
						}}
					>
						<tbody>
							<tr>
								<td>
									<p
										style={{
											margin:"0px"
										  , fontWeight: "bold"
										}}
									>
										Net Income
									</p>
								</td>
								<td style={{textAlign: "right"}}>
									<span
										style={{
											fontWeight:"bold"
										  , color: props.incomeStatement.netIncome[propertyID]>0?"#212121":"#f44336"
										}}
									>
										{(props.incomeStatement.netIncome[propertyID]<0 &&'-' || '')+'$'+ Numeral(Math.abs(props.incomeStatement.netIncome[propertyID] || 0)).format('0,0')}
									</span>
								</td>
							</tr>
							<tr>
								<td>
									<p
										style={{
											margin:"0px"
										  , fontWeight: "bold"
										  , fontSize: "14px"
										  , color: "#4c5661"
										  , paddingLeft: "15px"
										}}
									>
										Rent Income
									</p>
								</td>
								<td style={{textAlign: "right"}}>
									<Tooltip
										visible={props.tooltips.rentIncome}
										trigger="click"
										overlay={<TooltipContent data={props.tooltipsData['rentIncome']} close={() => props.CLOSE_TOOLTIP('rentIncome')} />}
										placement="left"
									>
										<p
											style={{
												margin: "0"
											  , display: "inline-block"
											  , fontWeight:"bold"
											  , fontSize: "14px"
											  , color: props.incomeStatement.rentIncome[propertyID]>0?"#212121":"#f44336"
											}}
										>
											{(props.incomeStatement.rentIncome[propertyID]<0 &&'-' || '')+'$'+ Numeral(props.incomeStatement.rentIncome[propertyID]).format('0,0')}
											<span
												style={{
													borderBottom: `1px dotted ${props.incomeStatement.rentIncome[propertyID]>0?"#212121":"#f44336"}`
												  , cursor: "pointer"
												}}
												onClick={(evt) => {evt.stopPropagation(); props.TOGGLE_TOOLTIP('rentIncome')}}
											>?</span>
										</p>
									</Tooltip>
								</td>
							</tr>
							<tr>
								<td>
									<p
										style={{
											margin:"0px"
										  , fontWeight: "bold"
										  , fontSize: "14px"
										  , color: "#4c5661"
										  , paddingLeft: "15px"
										}}
									>
										Expenses
									</p>
								</td>
								<td style={{textAlign: "right"}}>
									<Tooltip
										visible={props.tooltips.expenses}
										trigger="click"
										overlay={<TooltipContent data={props.tooltipsData['expenses']} close={() => props.CLOSE_TOOLTIP('expenses')} />}
										placement="left"
									>
										<p
											style={{
												margin: "0"
											  , display: "inline-block"
											  , fontWeight:"bold"
											  , fontSize: "14px"
											  , color: props.incomeStatement.expenses[propertyID].total>0?"#212121":"#f44336"
											}}
										>
											{(props.incomeStatement.expenses[propertyID].total<0 &&'-' || '')+'$'+ Numeral(props.incomeStatement.expenses[propertyID].total).format('0,0')}
											<span
												style={{
													borderBottom: `1px dotted ${props.incomeStatement.expenses[propertyID].total>0?"#212121":"#f44336"}`
												  , cursor: "pointer"
												}}
												onClick={(evt) => {evt.stopPropagation(); props.TOGGLE_TOOLTIP('expenses')}}
											>?</span>
										</p>
									</Tooltip >
								</td>
							</tr>
						</tbody>
					</table>
					<Divider style={{margin:"0px 0px 10px 0px", width: "100%"}}/>
					<table
						style={{
							width: "100%"
						  , verticalAlign:"top"
						  , padding: "0 0px 15px 10px"
						  , fontSize: "16px", lineHeight: "2"
						}}
					>
						<tbody>
							<tr>
								<td>
									<p
										style={{
											margin:"0px"
										  , fontWeight: "bold"
										}}
									>
										Current Value <span style={{fontWeight: "normal", fontSize: "14px", color: "#4C5660"}}>estimated</span>
									</p>
								</td>
								<td style={{textAlign: "right"}}>
									<Tooltip
										visible={props.tooltips.currentValue}
										trigger="click"
										overlay={<TooltipContent data={props.tooltipsData['currentValue']} close={() => props.CLOSE_TOOLTIP('currentValue')} />}
										placement="left"
									>
										<p
											style={{
												margin: "0"
											  , display: "inline-block"
											  , fontWeight:"bold"
											  , fontSize: "14px"
											  , color: props.equity[propertyID].equity>0?"#212121":"#f44336"
											}}
										>
											{(props.equity[propertyID] && props.equity[propertyID].equity<0 &&'-' || '')+'$'+ Numeral(Math.abs(props.equity[propertyID] && props.equity[propertyID].equity || 0)).format('0,0')}
											<span
												style={{
													borderBottom: `1px dotted ${props.equity[propertyID].equity>0?"#212121":"#f44336"}`
												  , cursor: "pointer"
												}}
												onClick={(evt) => {evt.stopPropagation(); props.TOGGLE_TOOLTIP('currentValue')}}
											>?</span>
										</p>
									</Tooltip>
								</td>
							</tr>
							<tr>
								<td>
									<p
										style={{
											margin:"0px"
										  , fontWeight: "bold"
										}}
									>
										Value Gain <span style={{fontWeight: "normal", fontSize: "14px", color: "#4C5660"}}>estimated</span>
									</p>
								</td>
								<td style={{textAlign: "right"}}>
									<Tooltip
										visible={props.tooltips.valueGain}
										trigger="click"
										overlay={<TooltipContent data={props.tooltipsData['valueGain']} close={() => props.CLOSE_TOOLTIP('valueGain')} />}
										placement="left"
									>
										<p
											style={{
												margin: "0"
											  , display: "inline-block"
											  , fontWeight:"bold"
											  , fontSize: "14px"
											  , color: props.equity[propertyID].gain>=0?"#212121":"#f44336"
											}}
										>
											{(props.equity[propertyID] && props.equity[propertyID].gain<0 &&'-' || '')+'$'+ Numeral(Math.abs(props.equity[propertyID] && props.equity[propertyID].gain || 0)).format('0,0')}
											<span
												style={{
													borderBottom: `1px dotted ${props.equity[propertyID].gain>=0?"#212121":"#f44336"}`
												  , cursor: "pointer"
												}}
												onClick={(evt) => {evt.stopPropagation(); props.TOGGLE_TOOLTIP('valueGain')}}
											>?</span>
										</p>
									</Tooltip>
								</td>
							</tr>
							<tr>
								<td>
									<p
										style={{
											margin:"0px"
										  , fontWeight: "bold"
										}}
									>
										Loan Principal Paid
									</p>
								</td>
								<td style={{textAlign: "right"}}>
									<Tooltip
										visible={props.tooltips.loanPrincipalPaid}
										trigger="click"
										overlay={<TooltipContent data={props.tooltipsData['loanPrincipalPaid']} close={() => props.CLOSE_TOOLTIP('loanPrincipalPaid')} />}
										placement="left"
									>
										<p
											style={{
												margin: "0"
											  , display: "inline-block"
											  , fontWeight:"bold"
											  , fontSize: "14px"
											  , color: "#212121"
											}}
										>
											${Numeral(props.principalPaid[propertyID]).format('0,0')}
											<span
												style={{
													borderBottom: "1px dotted #212121"
												  , cursor: "pointer"
												}}
												onClick={(evt) => {evt.stopPropagation(); props.TOGGLE_TOOLTIP('loanPrincipalPaid')}}
											>?</span>
										</p>
									</Tooltip>
								</td>
							</tr>
							<tr>
								<td>
									<p
										style={{
											margin:"0px"
										  , fontWeight: "bold"
										}}
									>
										Tax Deferral
										<Link
											to={{
												pathname: '/landlord/profile/'+props.currentUser
											  , query: { taxDeferral: 'true' }
											}}
											style={{
												borderBottom: "1px solid black"
											  , textDecoration: "none"
											  , marginLeft: "10px"
											}}
										>
											<span style={{fontWeight: "normal", fontSize: "14px", color: "#4C5660"}}>at {props.taxBracket}%</span>
										</Link>
									</p>
								</td>
								<td style={{textAlign: "right"}}>
									<Tooltip
										visible={props.tooltips.taxDeferal}
										trigger="click"
										overlay={<TooltipContent data={props.tooltipsData['taxDeferal']} close={() => props.CLOSE_TOOLTIP('taxDeferal')} />}
										placement="left"
									>
										<p
											style={{
												margin: "0"
											  , display: "inline-block"
											  , fontWeight:"bold"
											  , fontSize: "14px"
											  , color: "#212121"
											}}
										>
											{(props.taxDeferal[propertyID]<0 &&'-' || '')+'$'+ Numeral(Math.abs(props.taxDeferal[propertyID] || 0)).format('0,0')}
											<span
												style={{
													borderBottom: "1px dotted #212121"
												  , cursor: "pointer"
												}}
												onClick={(evt) => {evt.stopPropagation(); props.TOGGLE_TOOLTIP('taxDeferal')}}
											>?</span>
										</p>
									</Tooltip>
								</td>
							</tr>
							<tr>
								<td>
									<p
										style={{
											margin:"0px"
										  , fontWeight: "bold"
										}}
									>
										Investment
									</p>
								</td>
								<td style={{textAlign: "right"}}>
									<span
										style={{
											fontWeight:"bold"
										  , color: "#212121"
										}}
									>
										${Numeral(props.investment[propertyID]).format('0,0')}
									</span>
								</td>
								</tr>
							<tr>
								<td>
									<p
										style={{
											margin:"0px"
										  , fontWeight: "bold"
										}}
									>
										ROI
									</p>
								</td>
								<td style={{textAlign: "right"}}>
									<Tooltip
										visible={props.tooltips.roi}
										trigger="click"
										overlay={<TooltipContent data={props.tooltipsData['roi']} close={() => props.CLOSE_TOOLTIP('roi')} />}
										placement="left"
									>
										<p
											style={{
												margin: "0"
											  , display: "inline-block"
											  , fontWeight:"bold"
											  , fontSize: "14px"
											  , color: props.roi[propertyID]>=0?"#212121":"#f44336"
											}}
										>
											{Numeral(props.roi[propertyID]).format('0,0')}%
											<span
												style={{
													borderBottom: `1px dotted ${props.roi[propertyID]>=0?"#212121":"#f44336"}`
												  , cursor: "pointer"
												}}
												onClick={(evt) => {evt.stopPropagation(); props.TOGGLE_TOOLTIP('roi')}}
											>?</span>
										</p>
									</Tooltip>
								</td>
								</tr>
								<tr>
									<td>
										<p
											style={{
												margin:"0px"
											  , fontWeight: "bold"
											}}
										>
											ROI <span style={{fontWeight: "normal", fontSize: "14px", lineHeight: "2", color: "#4C5660"}}>including Capital Gain</span>
										</p>
									</td>
									<td style={{textAlign: "right"}}>
										<Tooltip
											visible={props.tooltips.roiGain}
											trigger="click"
											overlay={<TooltipContent data={props.tooltipsData['roiGain']} close={() => props.CLOSE_TOOLTIP('roiGain')} />}
											placement="left"
										>
											<p
												style={{
													margin: "0"
												  , display: "inline-block"
												  , fontWeight:"bold"
												  , fontSize: "14px"
												  , color: props.roiWithGain[propertyID]>=0?"#212121":"#f44336"
												}}
											>
												{Numeral(props.roiWithGain[propertyID]).format('0,0')}%
												<span
													style={{
														borderBottom: `1px dotted ${props.roiWithGain[propertyID]>=0?"#212121":"#f44336"}`
													  , cursor: "pointer"
													}}
													onClick={(evt) => {evt.stopPropagation(); props.TOGGLE_TOOLTIP('roiGain')}}
												>?</span>
											</p>
										</Tooltip>
									</td>
								</tr>
						</tbody>
					</table>
					<Divider style={{margin:"0px 0px 10px 0px", width: "100%"}}/>
					<table
						style={{
							width: "100%"
						  , verticalAlign:"top"
						  , padding: "0 0px 15px 10px"
						  , fontSize: "16px", lineHeight: "2"
						}}
					>
						<tbody>
							<tr>
								<td>
									<p
										style={{
											margin:"0px"
										  , fontWeight: "bold"
										}}
									>
										Occupancy rate
									</p>
								</td>
								<td style={{textAlign: "right"}}>
									<Tooltip
										visible={props.tooltips.occupancyRate}
										trigger="click"
										overlay={<TooltipContent data={props.tooltipsData['occupancyRate']} close={() => props.CLOSE_TOOLTIP('occupancyRate')} />}
										placement="left"
									>
										<p
											style={{
												margin: "0"
											  , display: "inline-block"
											  , fontWeight:"bold"
											  , fontSize: "14px"
											  , color: "#212121"
											}}
										>
											{Numeral(props.occupancyRate[propertyID]).format('0,0')}%
											<span
												style={{
													borderBottom: "1px dotted #212121"
												  , cursor: "pointer"
												}}
												onClick={(evt) => {evt.stopPropagation(); props.TOGGLE_TOOLTIP('occupancyRate')}}
											>?</span>
										</p>
									</Tooltip>
								</td>
							</tr>
							<tr>
								<td>
									<p
										style={{
											margin:"0px"
										  , fontWeight: "bold"
										}}
									>
										Avg Days For Rent</p>
								</td>
								<td style={{textAlign: "right"}}>
									<Tooltip
										visible={props.tooltips.daysForRent}
										trigger="click"
										overlay={<TooltipContent data={props.tooltipsData['daysForRent']} close={() => props.CLOSE_TOOLTIP('daysForRent')} />}
										placement="left"
									>
										<p
											style={{
												margin: "0"
											  , display: "inline-block"
											  , fontWeight:"bold"
											  , fontSize: "14px"
											  , color: "#212121"
											}}
										>
											{Numeral(props.daysForRent[propertyID]).format('0,0')}
											<span
												style={{
													borderBottom: "1px dotted #212121"
												  , cursor: "pointer"
												}}
												onClick={(evt) => {evt.stopPropagation(); props.TOGGLE_TOOLTIP('daysForRent')}}
											>?</span>
										</p>
									</Tooltip>
								</td>
							</tr>
						</tbody>
					</table>
				</CardText>
			</Card>
		)
	}
}

export default connect(select, {...financeActions, ...tooltipsActions})(PerfomanceSection)



// WEBPACK FOOTER //
// ./src/routes/landlord/dashboard/PerfomanceSection.js